import type { TranslationKey } from "../locales";
import type { Enums } from "../types";

export function getAbsenceCategoryTranslationKey(
	category: Enums<"absenceCategory">,
): TranslationKey {
	switch (category) {
		case "vacation":
			return "absences.category.vacation";
		case "sick":
			return "absences.category.sick";
		case "compensation":
			return "absences.category.compensation";
		case "leave":
			return "absences.category.leave";
	}
}
